import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Admin } from './pages/Admin';
import { seedIfEmpty } from './lib/store';
export function App() {
  useEffect(() => {
    seedIfEmpty();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3farerqim1s43">
      <Routes data-id="element-1" data-mp="3fa87d3ql6m4b">
        <Route path="/" element={<Home data-id="element-3" data-mp="3fb9if87lr8m1" />} data-id="element-2" data-mp="3fbj8swwk7hs9" />
        <Route path="/admin" element={<Admin data-id="element-5" data-mp="2rkdxmv1kddoa" />} data-id="element-4" data-mp="3f8nedijx7b8k" />
        <Route path="*" element={<Home data-id="element-7" data-mp="2rl6vf6ijosua" />} data-id="element-6" data-mp="2rlyq8f4bimji" />
      </Routes>
    </BrowserRouter>;
}